// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet_root__Qj02N"};